declare var window: any;

const RemoveNotification = {
  mounted(this: any) {
    this.el.addEventListener("click", (_e: any) => {
      const notification_id = this.el.getAttribute("phx-value-notification_id");
      window.removeNotification(notification_id);
      this.pushEvent("remove_notification", {
        notification_id: notification_id,
      });
    });
  },
};

export default RemoveNotification;
